/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { chakra } from 'chakra-v3';
import { buttonRecipe } from '../../theme/recipes/Button.recipe';

/**
 * Button component created directly from the button recipe.
 * This is the recommended approach according to Chakra UI documentation.
 *
 * Variants (matching Figma design):
 * - 'cta' / 'primary': Dark teal background (#055369) with white border
 * - 'secondary': Transparent background with white border
 * - 'tertiary': Transparent background, no border
 * - 'outline': Transparent with teal border (for light backgrounds)
 * - 'selected': Radial gradient background with secondary blue text and border (for selected preference buttons)
 * - 'selectedWithIcon': Solid dark teal background with secondary blue text and border, includes gap for icon spacing
 *
 * Sizes: 'md' (default)
 *
 * All buttons: 48px min-height, 16px horizontal padding, 12px vertical padding,
 * 4px border radius, DM Sans SemiBold 16px font
 */
export const Button = chakra('button', buttonRecipe);

